import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "34",
  height: "42",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#600B66",
  stroke: "#fff",
  "stroke-width": "2",
  d: "m18.153 40.617-.057.042c-.427.317-.94.38-1.352.321s-.885-.261-1.205-.682l-.003-.004L4.209 25.59l-.001-.001C2.165 22.946 1 19.759 1 16.382 1 7.854 8.239 1 17 1s16 6.854 16 15.382c0 3.376-1.165 6.564-3.208 9.207zm0 0 .051-.05.167-.167.048-.047.04-.052 11.332-14.71z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#fff",
  d: "M19.649 12.266v-1.318c0-.878-.834-1.756-5.163-1.756-4.328 0-5.162.879-5.162 1.756v1.318c-.437 0-.795.395-.795.879v.879c0 .483.358.878.795.878v4.832c0 .483.238.922.596 1.142v.834c0 .616.437 1.098.992 1.098.556 0 .993-.483.993-1.098v-.66h5.162v.66c0 .615.437 1.097.993 1.097s.992-.483.992-1.098v-.834c.358-.22.596-.659.596-1.142v-4.832c.438 0 .796-.395.796-.878v-.879c0-.483-.358-.878-.795-.878m-7.942-1.757h5.56c.238 0 .397.176.397.44 0 .263-.159.438-.397.438l-5.56.001c-.239 0-.397-.175-.397-.439-.001-.264.158-.44.397-.44m-.795 9.663c-.437 0-.794-.395-.794-.879 0-.483.357-.878.794-.878s.795.395.795.878c0 .484-.358.879-.795.879m7.149 0c-.437 0-.795-.395-.795-.879 0-.483.358-.878.795-.878s.794.395.794.878c0 .484-.357.879-.794.879m.794-4.392c0 .703-.516 1.318-1.191 1.318h-6.355c-.675 0-1.191-.615-1.191-1.318v-2.196c0-.747.516-1.318 1.191-1.318h6.354c.675 0 1.191.57 1.191 1.318z"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#fff",
  "fill-rule": "evenodd",
  d: "M24.073 10.894c1.06 0 1.927.867 1.927 1.927 0 .941-.682 1.729-1.577 1.894v7.737a.364.364 0 0 1-.35.355.364.364 0 0 1-.35-.355v-7.737a1.93 1.93 0 0 1-1.577-1.894c0-1.06.867-1.927 1.927-1.927m0 3.154a1.226 1.226 0 1 1 0-2.453 1.226 1.226 0 0 1 0 2.453",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }